import { PermissionService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { SettingsDefinitionModel } from 'src/core/models/shared/settings-definition.model';
import { FeatureService } from 'src/core/services/feature/feature.service';

@Component({
  selector: 'ca-automatic-quality-management-setting-group',
  templateUrl: './automatic-quality-management-setting-group.component.html',
  styleUrl: './automatic-quality-management-setting-group.component.scss',
  standalone: false,
})
export class AutomaticQualityManagementSettingGroupComponent implements OnInit {
  activeTab: number = 1;

  qualityManagementEnabled: boolean = false;

  hasReasonPoolPermission: boolean = false;
  canManageSettings: boolean = false;

  settingsDefinitionItems: SettingsDefinitionModel[] = [
    {
      label: 'QualityManagement::ReasonPool',
      navigationData: ['administration', 'reason'],
      extraData: null,
      requiredPolicies: [PermissionConstants.ReasonPool],
      forFeatures: [FeatureConstants.QualityManagement],
    },
  ];

  constructor(
    private featureService: FeatureService,
    private permissionService: PermissionService
  ) {
    this.qualityManagementEnabled = this.featureService.isEnabled(
      FeatureConstants.QualityManagement
    );
    this.hasReasonPoolPermission = this.permissionService.getGrantedPolicy(
      PermissionConstants.ReasonPool
    );
    this.canManageSettings = this.permissionService.getGrantedPolicy(
      PermissionConstants.SettingManagement
    );
  }

  ngOnInit(): void {
    if (this.canManageSettings) {
      this.activeTab = 1;
    } else {
      this.activeTab = 2;
    }
  }
}
